import {
  Box,
  Paper,
  Typography,
  Stack,
  Chip,
} from "@mui/material";

import MenuBookIcon from "@mui/icons-material/MenuBook";
import PersonIcon from "@mui/icons-material/Person";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import SchoolIcon from "@mui/icons-material/School";

function References({ plant }) {
  if (!plant?.references?.length) return null;

  return (
    <Paper
      elevation={0}
      sx={{
        mt: 5,
        p: {
          xs: 3,
          md: 4,
        },
        borderRadius: 5,
        background:
          "linear-gradient(135deg,#FFFFFF,#F8FBFC)",
        border: "1px solid #E4EDF2",
        boxShadow: "0 10px 30px rgba(11,60,93,.08)",
      }}
    >
      {/* Header */}

      <Stack
        direction="row"
        spacing={2}
        alignItems="center"
        mb={3}
      >
        <Box
          sx={{
            width: 55,
            height: 55,
            borderRadius: "50%",
            bgcolor: "#EEF5FA",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <MenuBookIcon
            sx={{
              color: "#0B3C5D",
            }}
          />
        </Box>

        <Box>
          <Typography
            sx={{
              fontSize: {
                xs: "1.5rem",
                md: "2rem",
              },
              fontWeight: 700,
              color: "#0B3C5D",
            }}
          >
            References
          </Typography>

          <Typography
            color="text.secondary"
            fontSize={15}
          >
            Scientific publications and literature cited
          </Typography>
        </Box>
      </Stack>

      {/* Accent */}

      <Box
        sx={{
          width: 90,
          height: 4,
          bgcolor: "#43A047",
          borderRadius: 10,
          mb: 4,
        }}
      />

      <Stack spacing={3}>
        {plant.references.map((ref, index) => (
          <Paper
            key={index}
            elevation={0}
            sx={{
              p: 3,
              borderRadius: 4,
              border: "1px solid #E5EDF3",
              background: "#FFFFFF",
              transition: ".35s",

              "&:hover": {
                transform: "translateY(-5px)",
                boxShadow:
                  "0 12px 30px rgba(11,60,93,.12)",
              },
            }}
          >
            {/* Reference Number */}

            <Chip
              label={`Reference ${index + 1}`}
              sx={{
                mb: 2,
                bgcolor: "#EEF5FA",
                color: "#0B3C5D",
                fontWeight: 700,
              }}
            />

            {/* Title */}

            <Typography
              sx={{
                fontWeight: 700,
                color: "#0B3C5D",
                fontSize: "1.15rem",
                mb: 2,
              }}
            >
              {ref.title}
            </Typography>

            {/* Authors */}

            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
              mb={1}
            >
              <PersonIcon
                sx={{
                  color: "#0B3C5D",
                  fontSize: 20,
                }}
              />

              <Typography>
                <strong>Authors:</strong> {ref.authors}
              </Typography>
            </Stack>

            {/* Year */}

            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
              mb={2}
            >
              <CalendarTodayIcon
                sx={{
                  color: "#0B3C5D",
                  fontSize: 20,
                }}
              />

              <Typography>
                <strong>Year:</strong> {ref.year}
              </Typography>
            </Stack>

            {/* Journal */}

            <Stack
              direction="row"
              spacing={1}
              flexWrap="wrap"
              useFlexGap
            >
              {ref.journal && (
                <Chip
                  icon={<LibraryBooksIcon />}
                  label={ref.journal}
                  sx={{
                    bgcolor: "#F3F8FC",
                    color: "#0B3C5D",
                    fontWeight: 600,
                  }}
                />
              )}

              {ref.publisher && (
                <Chip
                  icon={<SchoolIcon />}
                  label={ref.publisher}
                  sx={{
                    bgcolor: "#EEF8F2",
                    color: "#2E7D32",
                    fontWeight: 600,
                  }}
                />
              )}

              {ref.source && (
                <Chip
                  label={ref.source}
                  sx={{
                    bgcolor: "#FFF8E8",
                    color: "#EF6C00",
                    fontWeight: 600,
                  }}
                />
              )}
            </Stack>

            {(ref.volume ||
              ref.issue ||
              ref.pages) && (
              <Box
                mt={3}
                pt={2}
                sx={{
                  borderTop:
                    "1px solid #EEF2F4",
                }}
              >
                <Typography
                  color="text.secondary"
                  sx={{
                    lineHeight: 1.8,
                  }}
                >
                  {ref.volume && (
                    <>
                      <strong>Volume:</strong>{" "}
                      {ref.volume}
                    </>
                  )}

                  {ref.issue && (
                    <>
                      {" • "}
                      <strong>Issue:</strong>{" "}
                      {ref.issue}
                    </>
                  )}

                  {ref.pages && (
                    <>
                      {" • "}
                      <strong>Pages:</strong>{" "}
                      {ref.pages}
                    </>
                  )}
                </Typography>
              </Box>
            )}
          </Paper>
        ))}
      </Stack>
    </Paper>
  );
}

export default References;